import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getAllData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { loaderActions } from '../../../../_actions/loader.actions';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatDate, formatDateyearmonthday, onlyNumeric } from '../../../commonClass/CommonValidation';
import ActivityBulkUpdateModal from './partial/ActivityBulkUpdateModal';
import { activityRateInventoryClose } from '../../../../_actions/user.action';

const ActivityInventory = (
    { ActivityName,
        ActivityBasicInfoId,
        disabled,
        dropdownData
    }) => {
    const displayDays = 5;
    const displayDaysArray = Array.from({ length: displayDays });
    const dispatch = useDispatch();
    const isUpdate = useSelector(store => store?.activityrateInventory?.isUpdate);
    const BulkUpdateDrodownList = [
        // { id: 1, name: 'Inventory', alias: 'Bulk Inventory' },
        { id: 2, name: 'Rates', alias: 'Bulk Rates' },
        // { id: 3, name: 'Blackout', alias: 'Blackout' }
    ]

    //#region inventory table row config (not for rates)
    const rowConfig = [
        {
            label: "Available",
            keyName: "InventoryStock",
            isInput: true
        },
        {
            label: "On Hold",
            keyName: "Hold",
            isInput: true
        },
        {
            label: "Sold",
            keyName: "SoldOut",
            isInput: false,
            badge: <span className="badge bg-light text-muted border ms-1" style={{ fontSize: '9px', fontWeight: '600', padding: '2px 4px' }}>auto</span>,
            cellClass: "text-center text-muted"
        },
        {
            label: "Total",
            keyName: "TotalCount",
            isInput: false,
            badge: <span className="badge bg-light text-muted border ms-1" style={{ fontSize: '9px', fontWeight: '600', padding: '2px 4px' }}>auto</span>,
            cellClass: "text-center fw-semibold text-dark"
        }
    ];
    //#endregion

    const [formValue, setFormValue] = useState({
        ActivityBasicInfoId: 0,
        SelecteDate: null,
        UserId: 0,
    })

    const [dropDownList, setDropDownList] = useState([])
    const [selectedactivity, setSelectedactivity] = useState(null)
    const [availabilityDates, setAvailabilityDates] = useState({
        StartDate: '',
        EndDate: ''
    })

    // set end date for calander (actual activity's end date - (displayDays - 1))
    const lastRequiredDate = selectedactivity?.basicData?.[0]?.ValidityToDate
        ? new Date(new Date(selectedactivity?.basicData?.[0]?.ValidityToDate)?.setDate(new Date(selectedactivity?.basicData?.[0]?.ValidityToDate)?.getDate() - (displayDays - 1)))
        : null;

    const [modalTitle, setModalTitle] = useState("")
    const [openModal, setOpenModal] = useState(false)
    const [modalTypeEdit, setModalTypeEdit] = useState(false)
    const [selectedCellDate, setSelectedCellDate] = useState(null)

    const [startDate, setStartDate] = useState(moment().startOf('day'));
    const [activityInventory, setActivityInventory] = useState([])
    const [expandedSlots, setExpandedSlots] = useState({})
    const [InventoryData, setInventoryData] = useState([])
    const [validationErrors, setValidationErrors] = useState([]);

    //#region check validation error
    const hasInputError = (slotValue, dateStr, keyName) => {
        const isSchedule = selectedactivity?.basicData?.[0]?.IsScheduleActivity;
        const slotId = (isSchedule && slotValue !== 'single-slot') ? slotValue : 0;
        return validationErrors?.some(
            (error) => error?.slotId === slotId && error?.dateStr === dateStr && (error?.keyName === keyName || error?.keyName === 'both')
        );
    };
    //#endregion

    //#region validate inventory
    const validateInventory = () => {
        const errors = [];

        InventoryData?.forEach(entry => {
            const stock = entry?.InventoryStock ?? 0;
            const hold = entry?.Hold ?? 0;
            const slotId = entry?.ActivityManageActivitySlotId;
            const dateStr = entry?.ActivityInvDate;

            if (stock > 999999) {
                errors.push({
                    slotId,
                    dateStr,
                    keyName: 'InventoryStock',
                    message: "Max 6 Digit is allowed."
                });
            }
            if (hold > 999999) {
                errors.push({
                    slotId,
                    dateStr,
                    keyName: 'Hold',
                    message: "Max 6 Digit is allowed."
                });
            }
            if (stock < hold) {
                errors.push({
                    slotId,
                    dateStr,
                    keyName: 'both',
                    message: "Available Count cannot be less than Hold Count."
                });
            }
        });

        setValidationErrors(errors);
        return errors?.length === 0;
    };
    //#endregion

    //#region call save api function
    const handleApplyButton = async () => {
        const isValid = validateInventory();
        if (isValid) {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                const user = GetLocalStorage();
                const payload = {
                    ActivityBasicInfoId: ActivityBasicInfoId,
                    InventoryData: InventoryData,
                    UserId: user?.userMasterID
                }

                const inventoryRes = await postUsersData("/master/v1/insertupdatebulkactivitymanageinventory", payload);
                if (inventoryRes?.status) {
                    await getactivitymanageinventory(availabilityDates?.StartDate, availabilityDates?.EndDate);
                    setInventoryData([]);
                    setValidationErrors([]);
                    dispatch({ type: 'ALERTING', message: inventoryRes?.message });
                    dispatch(loaderActions.end());
                }
                else {
                    dispatch({ type: 'ALERTING', message: inventoryRes?.message });
                    dispatch(loaderActions.end());
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                dispatch(loaderActions.end());
            }
        }
    }
    //#endregion

    //#region expand slot accordion
    useEffect(() => {
        const isSchedule = selectedactivity?.basicData?.[0]?.IsScheduleActivity;
        if (isSchedule === false) {
            setExpandedSlots({
                'single-slot': true
            });
        } else if (dropDownList?.slotList?.length > 0) {
            // Expand the first slot by default
            setExpandedSlots({
                [dropDownList.slotList[0].value]: true
            });
        }
    }, [dropDownList, selectedactivity])
    //#endregion

    //#region toggle slot accordion function
    const toggleSlot = (slotValue) => {
        setExpandedSlots((prev) => ({
            ...prev,
            [slotValue]: !prev[slotValue]
        }));
    };
    //#endregion

    //#region handle inventory change
    const handleInventoryChange = (slotValue, dateStr, keyName, newValue) => {
        const cleanValue = newValue?.replace(/[^0-9]/g, '');
        const intValue = cleanValue === '' ? 0 : parseInt(cleanValue, 10) || 0;

        const isSchedule = selectedactivity?.basicData?.[0]?.IsScheduleActivity;
        const slotId = (isSchedule && slotValue !== 'single-slot') ? slotValue : 0;
        setValidationErrors(prev => prev.filter(e => !(e.slotId === slotId && e.dateStr === dateStr)));

        setInventoryData(prev => {
            const existingEntry = prev?.find(x => x?.ActivityManageActivitySlotId === slotId && x?.ActivityInvDate === dateStr);
            const currentItem = activityInventory?.find(x => x?.ActivityInvDate === `${dateStr}T00:00:00`);

            let finalStock = 0;
            let finalHold = 0;

            if (isSchedule === false) {
                finalStock = keyName === 'InventoryStock' ? intValue : (existingEntry ? existingEntry?.InventoryStock : (currentItem?.InventoryStock ?? 0));
                finalHold = keyName === 'Hold' ? intValue : (existingEntry ? existingEntry?.Hold : (currentItem?.Hold ?? 0));
            } else {
                const currentSlot = currentItem?.Slots?.find(s => s?.ActivityManageActivitySlotId === slotValue);
                finalStock = keyName === 'InventoryStock' ? intValue : (existingEntry ? existingEntry?.InventoryStock : (currentSlot?.InventoryStock ?? 0));
                finalHold = keyName === 'Hold' ? intValue : (existingEntry ? existingEntry?.Hold : (currentSlot?.Hold ?? 0));
            }

            const updatedEntry = {
                ActivityManageActivitySlotId: slotId,
                ActivityInvDate: dateStr,
                InventoryStock: finalStock,
                Hold: finalHold
            };

            const existingIndex = prev?.findIndex(x => x?.ActivityManageActivitySlotId === slotId && x?.ActivityInvDate === dateStr);
            if (existingIndex > -1) {
                const newArr = [...prev];
                newArr[existingIndex] = updatedEntry;
                return newArr;
            } else {
                return [...prev, updatedEntry];
            }
        });
    };
    //#endregion

    //#region get (with slot/without slot) inventory value
    const defaultValue = {
        IsAvailable: false,
        message: "Not Available",
        value: 0
    }
    const getSlotInventoryValue = (slotValue, dateStr, keyName) => {
        const item = activityInventory?.find(
            (inv) => inv?.ActivityInvDate === `${dateStr}T00:00:00`
        );
        if (!item) return defaultValue;

        const isSchedule = selectedactivity?.basicData?.[0]?.IsScheduleActivity;
        const slotId = (isSchedule && slotValue !== 'single-slot') ? slotValue : 0;

        // Check if we have a modified value in InventoryData
        const modifiedEntry = InventoryData?.find(x => x?.ActivityManageActivitySlotId === slotId && x?.ActivityInvDate === dateStr);
        if (modifiedEntry && (keyName === 'InventoryStock' || keyName === 'Hold')) {
            const slot = isSchedule ? item?.Slots?.find(s => s?.ActivityManageActivitySlotId === slotValue) : null;
            const isAvailable = isSchedule ? (!!slot?.IsAvailable) : true;
            return {
                IsAvailable: isAvailable,
                message: "Not Available",
                value: modifiedEntry[keyName]
            };
        }

        // Default lookup
        if (isSchedule === false) {
            return { IsAvailable: true, message: "Not Available", value: item?.[keyName] ?? 0 };
        }
        const slot = item?.Slots?.find(s => s?.ActivityManageActivitySlotId === slotValue);
        return slot ? { IsAvailable: slot?.IsAvailable, message: "Not Available", value: slot?.[keyName] ?? 0 } : defaultValue;
    };
    //#endregion

    //#region get (with slot/without slot) rate value
    const getSlotRateValue = (slotValue, dateStr, paxTypeId) => {
        const item = activityInventory?.find(
            (inv) => inv?.ActivityInvDate === `${dateStr}T00:00:00`
        );
        if (!item) return defaultValue;
        const isSchedule = selectedactivity?.basicData?.[0]?.IsScheduleActivity;
        if (isSchedule === false) {
            const pax = item?.PaxPriceDetails?.find(p => p?.ActivityManagePaxTypeId === paxTypeId);
            return pax ? { IsAvailable: true, message: "Not Available", value: pax?.DisplayPrice ?? 0 } : defaultValue;
        }
        const slot = item?.Slots?.find(s => s?.ActivityManageActivitySlotId === slotValue);
        if (!slot) return defaultValue;
        const pax = slot?.PaxPriceDetails?.find(p => p?.ActivityManagePaxTypeId === paxTypeId);
        return pax ? { IsAvailable: slot?.IsAvailable, message: "Not Available", value: pax?.DisplayPrice ?? 0 } : defaultValue;
    };
    //#endregion

    //#region Days Range List API
    const getactivityinventoryotherinfo = async (id) => {
        const activityinventoryinfo = await getAllData(`/master/v1/getactivityinventoryotherinfo?ActivityBasicInfoId=${id}`)
        if (activityinventoryinfo?.status) {
            setSelectedactivity(activityinventoryinfo?.data);
            setDropDownList(activityinventoryinfo?.data);

            const StartDate = activityinventoryinfo?.data?.basicData?.[0]?.ValidityFromDate;
            const EndDate = activityinventoryinfo?.data?.basicData?.[0]?.ValidityToDate;

            const ActivityStartDate = setStartDateOfTable(StartDate, EndDate);
            setStartDate(ActivityStartDate);
            setAvailabilityDates((activity) => ({ ...activity, StartDate: StartDate, EndDate: EndDate }));

            try {
                await Promise.all([
                    getactivitymanageinventory(StartDate, EndDate)
                ])
            } catch (error) {
                console.error(`Error fetching data: ${error}`)
                dispatch(loaderActions.end());
            }
        }
        else {
            dispatch({ type: 'ALERTING', message: activityinventoryinfo?.message });
            dispatch(loaderActions.end());
        }
    }
    //#endregion

    //#region Rate and Inventory Values API
    const getactivitymanageinventory = async (StartDate, EndDate) => {

        const payloadData = {
            ActivityBasicInfoId: ActivityBasicInfoId,
            FromDate: StartDate ? `${formatDateyearmonthday(StartDate)}T00:00:00` : null,
            ToDate: EndDate ? `${formatDateyearmonthday(EndDate)}T00:00:00` : null,
        }

        const activityinventory = await postUsersData('/master/v1/getactivitymanageinventory', payloadData)
        if (activityinventory?.status) {
            const parsedInventory = activityinventory?.data?.map((item) => {
                return {
                    ...item,
                    Slots: typeof item?.Slots === 'string' ? JSON.parse(item?.Slots) : item?.Slots,
                    PaxPriceDetails: typeof item?.PaxPriceDetails === 'string' ? JSON.parse(item?.PaxPriceDetails) : item?.PaxPriceDetails
                };
            });
            setActivityInventory(parsedInventory);
            dispatch(activityRateInventoryClose());
            dispatch(loaderActions.end());
        }
        else {
            // dispatch({ type: 'ALERTING', message: activityinventory?.message });
            dispatch(loaderActions.end());
        }
    }
    //#endregion

    //#region call Rate and Inventory API function when Inventory or Rate updated through pop-up
    useEffect(() => {
        if (isUpdate) {
            dispatch(loaderActions.start());
            getactivitymanageinventory(availabilityDates?.StartDate, availabilityDates?.EndDate);
        }
    }, [isUpdate, availabilityDates])
    //#endregion

    //#region call Activity Dropdown value List API
    useEffect(() => {
        async function fetchData() {
            dispatch(loaderActions.start())
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                const user = GetLocalStorage();
                setFormValue((form) => ({ ...form, ActivityBasicInfoId: ActivityBasicInfoId, UserId: user?.userMasterID }))
                try {
                    await Promise.all([
                        getactivityinventoryotherinfo(ActivityBasicInfoId)
                    ])
                } catch (error) {
                    dispatch(loaderActions.end())
                    console.error(`Error fetching data: ${error}`)
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                dispatch(loaderActions.end())
            }
        }
        fetchData();
    }, [])
    //#endregion

    //#region Select Date On Change
    const handleSelectDate = (update) => {
        setFormValue(form => ({ ...form, SelecteDate: update }))
        setStartDate(moment(update))
    }
    //#endregion

    //#region Date Icon click function
    const openDatePicker = (e) => {
        document.querySelector("#" + e)?.click();
    };
    //#endregion

    //#region Table Start Date depends on activity validity from date
    const setStartDateOfTable = (startdate, enddate) => {
        return moment()?.startOf('day') <= new Date(startdate) ?
            moment(new Date(startdate))
            :
            moment()?.startOf('day') >= moment(new Date(enddate))?.clone()?.subtract(displayDays - 1, 'days') ?
                moment(new Date(enddate))?.clone()?.subtract(displayDays - 1, 'days')
                :
                moment()?.startOf('day')
    }
    //#endregion

    //#region Table Calander Previous button
    const goToPreviousWeek = (e) => {
        e.preventDefault()
        if (startDate?.clone()?.subtract(displayDays, 'days') <= new Date(selectedactivity?.basicData?.[0]?.ValidityFromDate)) {
            setStartDate(moment(new Date(selectedactivity?.basicData?.[0]?.ValidityFromDate)));
        }
        else {
            setStartDate(startDate?.clone()?.subtract(displayDays, 'days'));
        }
    };
    //#endregion

    //#region Table Calander Next button
    const goToNextWeek = (e) => {
        e.preventDefault()
        if (startDate?.clone()?.add(displayDays * 2 - 1, 'days') > new Date(selectedactivity?.basicData?.[0]?.ValidityToDate)) {
            setStartDate(moment(lastRequiredDate));
        }
        else {
            setStartDate(startDate?.clone()?.add(displayDays, 'days'));
        }
    };
    //#endregion

    //#region handle Bulk Update Modals
    const handleModal = (name) => {
        setModalTitle(name)
        setOpenModal(true)
        setModalTypeEdit(false)
        setSelectedCellDate(null)
    }
    //#endregion

    //#region handle Edit Modals
    const handleEdit = (e, name, cellDate) => {
        e.preventDefault()
        setModalTitle(name)
        setOpenModal(true)
        setModalTypeEdit(true)
        setSelectedCellDate(cellDate)
    }
    //#endregion

    return (
        <div className="my-5 activity-inventory-wrapper">
            <div className="container-fluid form_border my-2 py-3 activity_inventory_DatePicker">
                <>
                    {
                        openModal &&
                        <ActivityBulkUpdateModal
                            open={openModal}
                            title={modalTitle}
                            isEdit={modalTypeEdit}
                            selectedCellDate={selectedCellDate}
                            availabilityDates={availabilityDates}
                            setOpenModal={setOpenModal}
                            activityInventory={activityInventory}
                            dropDownList={dropDownList}
                            ActivityBasicInfoId={formValue?.ActivityBasicInfoId}
                            ActivityName={ActivityName}
                            UserId={formValue?.UserId}
                            dropdownData={dropdownData}
                        />
                    }
                    <div className="container-fluid mt-2 heading_color input_mui">
                        {/* Upper controls row matching mockup */}
                        <div className="d-flex flex-wrap align-items-end justify-content-between gap-3 mb-4 mt-3 etm-top-bar">
                            <div className="d-flex flex-wrap align-items-end gap-3 flex-grow-1">
                                <div className="form-group mb-0 activity-name-input-group">
                                    <label htmlFor="ActivityName" className="form-label fw-semibold text-muted mb-1" style={{ fontSize: '12px' }}>Activity Name</label>
                                    <input
                                        type="text"
                                        className='form-control'
                                        name="ActivityName"
                                        id="ActivityName"
                                        disabled
                                        value={ActivityName}
                                        title={ActivityName}
                                        placeholder='ActivityName'
                                        readOnly
                                        style={{ height: '38px', fontSize: '14px' }}
                                    />
                                </div>
                                <div className="form-group mb-0 select-date-input-group">
                                    <label htmlFor="inventoryselectdaterange" className="form-label fw-semibold text-muted mb-1" style={{ fontSize: '12px' }}>Select Date</label>
                                    <div className='position-relative'>
                                        <DatePicker
                                            dateFormat="dd/MM/yyyy"
                                            className={`form-control ${disabled ? '' : 'bg-body'}`}
                                            id='inventoryselectdaterange'
                                            selected={formValue?.SelecteDate}
                                            title={formatDate(formValue?.SelecteDate)}
                                            placeholderText="Select Date"
                                            autoComplete='off'
                                            showMonthDropdown
                                            onChange={(e) => handleSelectDate(e)}
                                            minDate={selectedactivity?.basicData?.[0]?.ValidityFromDate ? new Date(selectedactivity?.basicData?.[0]?.ValidityFromDate) : new Date()}
                                            maxDate={lastRequiredDate ? lastRequiredDate : new Date()}
                                            showYearDropdown
                                            // disabled={disabled}
                                            dropdownMode='select'
                                            onFocus={(e) => e.target.readOnly = true}
                                            style={{ height: '38px', fontSize: '14px' }}
                                        />
                                        <span className="example-custom-input activityinventoryBtn"
                                            style={{ top: '50%', transform: 'translateY(-50%)', right: '10px' }}
                                            onClick={(e) => openDatePicker("inventoryselectdaterange")}
                                        ><i className="fa fa-calendar"></i></span>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex align-items-center gap-3 etm-top-bar-buttons">
                                <button
                                    type="button"
                                    className="btn btn-primary px-4 fw-semibold"
                                    style={{ height: '38px', backgroundColor: '#0777A9', borderColor: '#0777A9' }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleApplyButton();
                                    }}
                                    disabled={disabled || InventoryData?.length === 0}
                                >
                                    Apply
                                </button>
                                {
                                    selectedactivity ?
                                        <div className="dropdown" key="bulk-update-en">
                                            <div
                                                id="bulk_update_id"
                                                role="button"
                                                className="dropdown-toggle bulk_update_btn px-3 py-2 text-danger border rounded fw-semibold d-flex align-items-center gap-1"
                                                data-bs-toggle="dropdown" aria-expanded="false"
                                                disabled={disabled}
                                                style={{
                                                    border: '1px solid #ff4d6d !important',
                                                    color: '#ff4d6d',
                                                    borderColor: '#ff4d6d',
                                                    backgroundColor: 'transparent',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                Bulk Update
                                            </div>
                                            <div className="dropdown-menu dropdown-menu-end dropdown_zindexset bulkupdate_dropdown" aria-labelledby="bulk_update_id">
                                                <div className="bulk_dropdown">
                                                    {
                                                        BulkUpdateDrodownList?.map(element => {
                                                            return (
                                                                <div key={element?.id} className="bulk_dropdown_item py-2 px-3" role='button' onClick={() => handleModal(element)}>
                                                                    {element?.name}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="d-flex justify-content-end align-items-center" key="bulk-update-dis">
                                            <div disabled={disabled} className="px-3 py-2 text-muted border rounded fw-semibold" style={{ borderColor: '#ddd' }}> Bulk Update </div>
                                        </div>
                                }
                            </div>
                        </div>

                        {/* Mobile Pagination Controls */}
                        <div className="d-flex justify-content-between align-items-center mb-3 p-2 rounded bg-light hide-on-desktop">
                            <button
                                className="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
                                style={{ color: '#0777A9', borderColor: '#0777A9' }}
                                disabled={selectedactivity?.basicData?.[0]?.ValidityFromDate === undefined || startDate <= new Date(selectedactivity?.basicData?.[0]?.ValidityFromDate)}
                                onClick={(e) => goToPreviousWeek(e)}
                            >
                                <i className="fa fa-chevron-left" style={{ fontSize: '12px' }}></i> Prev
                            </button>
                            <span className="fw-bold text-dark" style={{ fontSize: '13px' }}>
                                {startDate.format('DD MMM')} - {startDate.clone().add(displayDays - 1, 'days').format('DD MMM YYYY')}
                            </span>
                            <button
                                className="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
                                style={{ color: '#0777A9', borderColor: '#0777A9' }}
                                disabled={selectedactivity?.basicData?.[0]?.ValidityToDate === undefined || startDate.clone().add(displayDays - 1, 'days') >= new Date(selectedactivity?.basicData?.[0]?.ValidityToDate)}
                                onClick={(e) => goToNextWeek(e)}
                            >
                                Next <i className="fa fa-chevron-right" style={{ fontSize: '12px' }}></i>
                            </button>
                        </div>

                        {/* Mobile "TOTAL (All Slots)" section */}
                        <div className="total-slots-mobile-list hide-on-desktop mb-4">
                            {displayDaysArray?.map((_, index) => {
                                const dateVal = startDate.clone().add(index, 'days');
                                const dateStr = dateVal.format('YYYY-MM-DD');
                                const item = activityInventory?.find(
                                    (inv) => inv?.ActivityInvDate === `${dateStr}T00:00:00`
                                );
                                const available = item?.InventoryStock ?? 0;
                                const onHold = item?.Hold ?? 0;
                                const sold = item?.SoldOut ?? 0;
                                const total = item?.TotalCount ?? 0;

                                return (
                                    <div key={index} className="total-slot-card p-3 mb-2 shadow-sm">
                                        <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                                            <span className="fw-bold text-dark">{dateVal.format('DD-MMM-YYYY')}</span>
                                            <span className="text-muted fw-semibold small">{dateVal.format('dddd')}</span>
                                        </div>
                                        <div className="row g-2 text-center">
                                            <div className="col-6 col-sm-3">
                                                <div className="p-2 rounded bg-light">
                                                    <div className="text-muted small mb-1" style={{ fontSize: '10px' }}>Available</div>
                                                    <div className="fw-bold text-primary" style={{ fontSize: '14px', color: '#0284c7' }}>{available}</div>
                                                </div>
                                            </div>
                                            <div className="col-6 col-sm-3">
                                                <div className="p-2 rounded bg-light">
                                                    <div className="text-muted small mb-1" style={{ fontSize: '10px' }}>On Hold</div>
                                                    <div className="fw-bold text-warning" style={{ fontSize: '14px', color: '#ea580c' }}>{onHold}</div>
                                                </div>
                                            </div>
                                            <div className="col-6 col-sm-3">
                                                <div className="p-2 rounded bg-light">
                                                    <div className="text-muted small mb-1" style={{ fontSize: '10px' }}>Sold</div>
                                                    <div className="fw-bold text-success" style={{ fontSize: '14px', color: '#16a34a' }}>{sold}</div>
                                                </div>
                                            </div>
                                            <div className="col-6 col-sm-3">
                                                <div className="p-2 rounded bg-light">
                                                    <div className="text-muted small mb-1" style={{ fontSize: '10px' }}>Total</div>
                                                    <div className="fw-bold text-dark" style={{ fontSize: '14px' }}>{total}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {/* Top "TOTAL (All Slots)" section matching mockup */}
                        <div className="total-slots-card mb-4 border rounded hide-on-mobile">
                            {/* Dates Header */}
                            <div className="dates-header-row d-flex align-items-stretch text-center" style={{ backgroundColor: '#f8fafd' }}>
                                <div className="dates-label-column d-flex justify-content-between align-items-center px-3 py-2 border-bottom flex-shrink-0" style={{ width: '20%', borderRight: '1px solid #e2e8f0' }}>
                                    <span className="fw-bold text-dark text-uppercase small tracking-wide" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Dates</span>
                                    <button
                                        className="btn btn-link p-0 text-decoration-none"
                                        style={{ color: '#0777A9', boxShadow: "none" }}
                                        disabled={selectedactivity?.basicData?.[0]?.ValidityFromDate === undefined || startDate <= new Date(selectedactivity?.basicData?.[0]?.ValidityFromDate)}
                                        onClick={(e) => goToPreviousWeek(e)}
                                    >
                                        <i className="fa-solid fa-chevron-left fa fa-chevron-left" style={{ fontSize: '12px' }}></i>
                                    </button>
                                </div>
                                {displayDaysArray?.map((_, index) => {
                                    const dateVal = startDate?.clone()?.add(index, 'days');
                                    const isLast = index === displayDays - 1;
                                    return (
                                        <div key={index} className="date-header-column d-flex align-items-center justify-content-center py-2 flex-grow-1 border-bottom position-relative" style={{ width: '16%', borderRight: isLast ? 'none' : '1px solid #e2e8f0' }}>
                                            <div className="d-flex flex-column align-items-center">
                                                <div className="fw-bold text-dark text-nowrap" style={{ fontSize: '13px' }}>
                                                    {dateVal?.format('DD-MMM-YYYY')}
                                                </div>
                                                <div className="text-muted fw-semibold" style={{ fontSize: '11px' }}>
                                                    {dateVal?.format('dddd')}
                                                </div>
                                            </div>
                                            {isLast && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none position-absolute"
                                                    style={{ right: '12px', color: '#0777A9', top: '50%', transform: 'translateY(-50%)', boxShadow: "none" }}
                                                    disabled={selectedactivity?.basicData?.[0]?.ValidityToDate === undefined || startDate?.clone()?.add(displayDays - 1, 'days') >= new Date(selectedactivity?.basicData?.[0]?.ValidityToDate)}
                                                    onClick={(e) => goToNextWeek(e)}
                                                >
                                                    <i className="fa-solid fa-chevron-right fa fa-chevron-right" style={{ fontSize: '12px' }}></i>
                                                </button>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>

                            {/* Total Values */}
                            <div className="total-values-row d-flex align-items-center" style={{ backgroundColor: "rgb(238, 245, 251)" }} >
                                <div className="dates-label-column d-flex align-items-center px-3 py-3 flex-shrink-0" style={{ background: "transparent", width: '20%', borderRight: '1px solid #e2e8f0' }}>
                                    <div className="total-icon-badge me-2 d-flex align-items-center justify-content-center" style={{ backgroundColor: '#e0f2fe', width: '32px', height: '32px', borderRadius: '6px' }}>
                                        <i className="fa fa-bar-chart" style={{ color: '#0777A9' }}></i>
                                    </div>
                                    <span className="fw-bold text-dark" style={{ fontSize: '13px' }}>TOTAL (All Slots)</span>
                                </div>
                                {displayDaysArray?.map((_, index) => {
                                    const dateStr = startDate?.clone()?.add(index, 'days')?.format('YYYY-MM-DD');
                                    const item = activityInventory?.find(
                                        (inv) => inv?.ActivityInvDate === `${dateStr}T00:00:00`
                                    );

                                    const available = item?.InventoryStock ?? 0;
                                    const onHold = item?.Hold ?? 0;
                                    const sold = item?.SoldOut ?? 0;
                                    const total = item?.TotalCount ?? 0;
                                    const isLast = index === displayDays - 1;

                                    return (
                                        <div key={index} className="date-values-column d-flex justify-content-around align-items-center py-2 flex-grow-1" style={{ background: "transparent", width: '16%', borderRight: isLast ? 'none' : '1px solid #e2e8f0' }}>
                                            <div className="d-flex flex-column align-items-center" style={{ background: "transparent" }} >
                                                <span className="text-muted fw-semibold mb-1" style={{ fontSize: '10px' }}>Available</span>
                                                <span className="fw-bold text-primary" style={{ fontSize: '14px', color: '#0284c7' }}>{available}</span>
                                            </div>
                                            <div className="d-flex flex-column align-items-center" style={{ background: "transparent" }} >
                                                <span className="text-muted fw-semibold mb-1" style={{ fontSize: '10px' }}>On Hold</span>
                                                <span className="fw-bold text-warning" style={{ fontSize: '14px', color: '#ea580c' }}>{onHold}</span>
                                            </div>
                                            <div className="d-flex flex-column align-items-center" style={{ background: "transparent" }} >
                                                <span className="text-muted fw-semibold mb-1" style={{ fontSize: '10px' }}>Sold</span>
                                                <span className="fw-bold text-success" style={{ fontSize: '14px', color: '#16a34a' }}>{sold}</span>
                                            </div>
                                            <div className="d-flex flex-column align-items-center" style={{ background: "transparent" }} >
                                                <span className="text-muted fw-semibold mb-1" style={{ fontSize: '10px' }}>Total</span>
                                                <span className="fw-bold text-dark" style={{ fontSize: '14px' }}>{total}</span>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Validation Error Messages */}
                        {validationErrors?.length > 0 && (
                            <div className="alert alert-danger py-2 px-3 mt-1 mb-4 rounded border-0" style={{ backgroundColor: '#fdf2f2', color: '#b91c1c' }}>
                                <div className="d-flex align-items-start gap-2" style={{ backgroundColor: '#fdf2f2', color: '#b91c1c' }}>
                                    <i className="fa fa-exclamation-triangle mt-1" style={{ fontSize: '14px', color: '#b91c1c' }}></i>
                                    <ul className="mb-0 ps-2" style={{ listStyleType: 'disc' }}>
                                        {Array.from(new Set(validationErrors?.map(e => e.message))).map((msg, idx) => (
                                            <li key={idx} className="fw-semibold" style={{ fontSize: '13px', color: '#b91c1c' }}>
                                                {msg}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        )}

                        {/* Slots Accordion List */}
                        <div className="slots-accordion-list mt-4">
                            {(selectedactivity?.basicData?.[0]?.IsScheduleActivity === false
                                ? [{
                                    value: 'single-slot',
                                    noSlot: true,
                                    SlotTimeRange: selectedactivity?.basicData?.[0]?.ScheduleActivityMessage || 'No specific time defined'
                                }]
                                : (dropDownList?.slotList || [])
                            )?.map((slot) => {
                                const isExpanded = !!expandedSlots[slot?.value];
                                return (
                                    <div key={slot?.value} className="slot-accordion-item border rounded mb-3 overflow-hidden shadow-sm">
                                        {/* Accordion Header */}
                                        <div
                                            className={`slot-accordion-header d-flex justify-content-between align-items-center px-3 py-3 ${isExpanded ? 'expanded' : ''}`}
                                            style={{ backgroundColor: '#f1f7fc', cursor: 'pointer' }}
                                            onClick={() => toggleSlot(slot?.value)}
                                        >
                                            <div className="d-flex align-items-center" style={{ backgroundColor: 'transparent' }} >
                                                {!slot?.noSlot && <span className="badge px-3 py-1 me-3 text-white fw-bold uppercase-text" style={{ backgroundColor: '#0777A9', borderRadius: '4px', fontSize: '11px', letterSpacing: '0.5px' }}>SLOT</span>}
                                                <span className="fw-bold text-dark me-2" style={{ fontSize: '14px' }}>{slot?.SlotTimeRange}</span>
                                            </div>
                                            <div>
                                                <i className="fa-solid fa fa-chevron-down slot-chevron" style={{ color: '#0777A9', fontSize: '14px' }}></i>
                                            </div>
                                        </div>

                                        {/* Accordion Body */}
                                        <div className={`slot-accordion-body-wrapper ${isExpanded ? 'expanded' : ''}`}>
                                            <div className={`slot-accordion-body bg-white ${isExpanded ? 'border-top' : ''}`}>
                                                <div className="table-responsive">
                                                    <table className="table slot-data-table align-middle mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: '20%' }}></th>
                                                                {displayDaysArray?.map((_, index) => {
                                                                    const dateVal = startDate?.clone()?.add(index, 'days');
                                                                    return (
                                                                        <th key={index} className="text-center text-muted fw-semibold" style={{ fontSize: '12px', width: '16%' }}>
                                                                            {dateVal?.format('ddd - DD-MMM')}
                                                                        </th>
                                                                    );
                                                                })}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {rowConfig?.map((row) => (
                                                                <tr key={row?.keyName}>
                                                                    <td className="fw-semibold text-dark text-start" style={{ fontSize: '13px' }}>
                                                                        {row?.label} {row?.badge}
                                                                    </td>
                                                                    {displayDaysArray?.map((_, index) => {
                                                                        const dateVal = startDate?.clone()?.add(index, 'days');
                                                                        const dateStr = dateVal?.format('YYYY-MM-DD');
                                                                        const { IsAvailable, message, value } = getSlotInventoryValue(slot?.value, dateStr, row?.keyName);
                                                                        const isPastDate = dateVal?.isBefore(moment()?.startOf('day'));

                                                                        if (row?.isInput) {
                                                                            return IsAvailable ? (
                                                                                <td key={index} className="text-center">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control text-center mx-auto"
                                                                                        value={value}
                                                                                        disabled={disabled || isPastDate}
                                                                                        maxLength={6}
                                                                                        onChange={(e) => handleInventoryChange(slot?.value, dateStr, row?.keyName, onlyNumeric(e?.target?.value))}
                                                                                        style={{ width: '80px', height: '34px', fontSize: '13px', border: hasInputError(slot?.value, dateStr, row?.keyName) ? '1.5px solid #dc3545' : '1px solid #ced4da', borderRadius: '4px', backgroundColor: (disabled || isPastDate) ? '#e9ecef' : '#fff', color: (disabled || isPastDate) ? '#6c757d' : '#2d3748' }}
                                                                                    />
                                                                                </td>
                                                                            ) : (
                                                                                <td key={index} className="text-center text-muted" style={{ fontSize: '13px' }}>
                                                                                    {message}
                                                                                </td>
                                                                            );
                                                                        } else {
                                                                            return (
                                                                                <td key={index} className={row?.cellClass} style={{ fontSize: '13px' }}>
                                                                                    {IsAvailable ? value : message}
                                                                                </td>
                                                                            );
                                                                        }
                                                                    })}
                                                                </tr>
                                                            ))}

                                                            {/* RATES (₹) Header Row */}
                                                            <tr>
                                                                <td colSpan={6} className="py-2 px-3 align-middle" style={{ backgroundColor: '#eef5fb' }}>
                                                                    <div className="d-flex justify-content-between align-items-center w-100" style={{ backgroundColor: 'transparent' }} >
                                                                        <span className="fw-bold text-primary text-dark" style={{ fontSize: '13px' }}> <span style={{ fontSize: '13px', color: '#0777A9' }}>•</span>  RATES (₹)</span>
                                                                        <button
                                                                            type="button"
                                                                            disabled={disabled}
                                                                            className="btn btn-primary btn-sm d-flex align-items-center px-3 py-1"
                                                                            style={{ backgroundColor: '#0777A9', borderColor: '#0777A9', borderRadius: '4px', fontSize: '12px', fontWeight: '500' }}
                                                                            onClick={(e) => handleEdit(e, { id: 2, name: 'Rates', alias: 'Rates' }, null)}
                                                                        >
                                                                            <i className="fa-solid fa-pencil fa fa-pencil me-1" style={{ fontSize: '10px' }}></i> Edit
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            {/* Pax Rates Rows */}
                                                            {dropDownList?.paxTypeList?.map((pax) => (
                                                                <tr key={pax?.PaxTypeId}>
                                                                    <td className="fw-semibold text-dark text-start" style={{ fontSize: '13px', paddingLeft: '15px' }}>{pax?.LabelName}</td>
                                                                    {displayDaysArray?.map((_, index) => {
                                                                        const dateStr = startDate?.clone()?.add(index, 'days')?.format('YYYY-MM-DD');
                                                                        const { IsAvailable, message, value } = getSlotRateValue(slot?.value, dateStr, pax?.PaxTypeId);
                                                                        return (
                                                                            <td key={index} className="text-center text-muted" style={{ fontSize: '13px' }}>
                                                                                {IsAvailable ? value : message}
                                                                            </td>
                                                                        );
                                                                    })}
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </>
            </div>
        </div>
    )
}

export default ActivityInventory